
// Login actionTypes
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

//Signup actionTypes
export const SIGNUP_REQUEST = "SIGNUP_REQUEST";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";

//budget patch request
export const PATCH_REQUEST = "PATCH_REQUEST";
export const PATCH_SUCCESS = "PATCH_SUCCESS";
export const PATCH_FAILURE = "PATCH_FAILURE";